import { Component } from "@angular/core";
import { TranslatePipe } from "@ngx-translate/core";
import { SharedModule } from "@shared/shared.module";

@Component({
	selector: "app-legal-notes",
	imports: [
		SharedModule,
		TranslatePipe
	],
	templateUrl: "./legal-notes.component.html",
	styleUrl: "./legal-notes.component.scss",
})
export class LegalNotesComponent { }